import React from 'react'
import clsx from 'clsx'

import { TableCell } from '@material-ui/core'

import { SyncLogsButton } from './SyncLogsButton'
import { CombinedOrderSyncLogsButton } from './CombinedOrderSyncLogsButton'

import { useTableStyles } from '../../hooks/tableStylesHook'

import { MyRowProps } from '../../types/tableTypes'
import { StoreIntegrationType } from '../../types/integrationTypeUtils'

import { IntegrationType } from '../../server/mpsklad_core/Entity/IntegrationType'
import { WbOrderModel } from '../../server/mpsklad_core/Models/Orders/WbOrderModel'
import { OzonOrderModel } from '../../server/mpsklad_core/Models/Orders/OzonOrderModel'
import { StoreOrderModelBase } from '../../server/mpsklad_core/Models/Orders/StoreOrderModelBase'
import { YandexMarketOrderModel } from '../../server/mpsklad_core/Models/Orders/YandexMarketOrderModel'

export type StoreOrderSyncLogsCellProps =
  MyRowProps<StoreOrderModelBase>
  & {
  type: StoreIntegrationType

  isSelected?: boolean
}

export const StoreOrderSyncLogsCell =
  ({type, row, isSelected}: StoreOrderSyncLogsCellProps) => {
    const classes = useTableStyles()

    return (
      <TableCell className={clsx('table-border', classes.noWrapCell, isSelected && 'selected_row')}>
        <SyncLogsButton themed type={type} accountId={row.accountId} orderId={row.id}/>

        {
          !!row.moySkladOrderId &&
          <>
            <SyncLogsButton themed type={IntegrationType.MoySklad} orderId={row.moySkladOrderId}/>

            <CombinedOrderSyncLogsButton msOrderId={row.moySkladOrderId}/>
          </>
        }
      </TableCell>
    )
  }

export const OzonOrderSyncLogsCell =
  ({row, isSelected}: MyRowProps<OzonOrderModel>) =>
    <StoreOrderSyncLogsCell type={IntegrationType.Ozon} row={row} isSelected={isSelected}/>

export const WbOrderSyncLogsCell =
  ({row, isSelected}: MyRowProps<WbOrderModel>) =>
    <StoreOrderSyncLogsCell type={IntegrationType.Wildberries} row={row} isSelected={isSelected}/>

export const YandexMarketOrderSyncLogsCell =
  ({row, isSelected}: MyRowProps<YandexMarketOrderModel>) =>
    <StoreOrderSyncLogsCell type={IntegrationType.YandexMarket} row={row} isSelected={isSelected}/>